import React from "react"
import { notFoundContainer } from "../styles/not-found.module.scss"
import { NotFoundImageComponent } from "../styled-components/not-found-styled"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="Page non trouvée" />
    <div className={notFoundContainer}>
      <h1>La page n&apos;a pas été trouvée</h1>
      <NotFoundImageComponent />
    </div>
  </Layout>
)

export default NotFoundPage
